import React from "react";
import * as styles from "../styles/components/timeline.module.css";
import Container from "./container";
import timelineDiamond from "../images/timeline-diamond.svg";
import { imageUrlFor } from "../lib/image-url";
import { buildImageObj, cn } from "../lib/helpers";
import PortableText from "./portableText";

const Timeline = (props) => {
  const { name, events, stats, image } = props;

  return (
    <div className={styles.root} id="timeline">
      <img
        src={imageUrlFor(buildImageObj(image)).auto("format").url()}
        className={styles.timelineImage}
        alt="Timeline Image"
      />
      {name && (
        <div className={styles.rootHeader}>
          <h2 className={styles.title}>{name}</h2>
          {props._rawDescription && (
            <div className={cn("entry-content", styles.description)}>
              <PortableText blocks={props._rawDescription} />
            </div>
          )}
        </div>
      )}
      { stats && stats.length > 0 &&
      <div className={styles.statsWrapper}>
        {stats.map((stat, index) => (
          <div key={index} className={styles.stat}>
            <div className={styles.statTitle}>{stat.title}</div>
            <div className={styles.statDescription}>{stat.value}</div>
          </div>
        ))}
      </div>
}

      <Container>
        <div className={styles.timeline}>
          <div className={styles.smallLine} />
          {events.map((event, index) => (
            <TimelineEvent
              key={index}
              year={event.year}
              description={event.description}
              top={index % 2 === 0}
            />
          ))}
        </div>
      </Container>
    </div>
  );
};

const TimelineUI = ({ year, description, top }) => {
  return (

    <>
       <div className={styles.imageLine}>
      <img src={timelineDiamond} alt="diamond" className={styles.diamond} />
      <div className={styles.line} />
      <div className={top ? styles.timelineDataTop : styles.timelineData}>
        {top ? (
          <>
            <div className={styles.year}>{year}</div>
            <div className={styles.description}>{description}</div>
          </>
        ) : (
          <>
            <div className={styles.description}>{description}</div>
            <div className={styles.year}>{year}</div>
          </>
        )}
      </div>
    </div>
       <div className={styles.mobileTimelineWrapper}>
       <div className={styles.diamondLine}>
         <img src={timelineDiamond} alt="diamond" className={styles.diamond} />
         <div className={styles.mobileLine} />
       </div>
       <div className={styles.mobileTimeLine}>
         <div className={styles.year}>{year}</div>
         <div className={styles.description}>{description}</div>
       </div>
     </div>
    </>
  ) ;
};

const TimelineEvent = (props) => (
  <div className={styles.timelineEvent}>
    <TimelineUI {...props} />
  </div>
);

export default Timeline;
